import { ApiError } from '@shared/api-client';
import * as React from 'react';

/**
 * Turns an unknown thrown value into one message a form can display.
 *
 * Only `ApiError` carries a message meant for a person; anything else is a bug
 * or a network failure and gets a generic line rather than leaking internals.
 */
export const toErrorMessage = (error: unknown): string => {
  if (error instanceof ApiError) {
    return error.message;
  }

  if (error instanceof TypeError) {
    return 'Could not reach the server. Check your connection and try again.';
  }

  return 'Something went wrong. Please try again.';
};

export const useFormError = () => {
  const [error, setError] = React.useState<string | null>(null);

  const captureError = React.useCallback((err: unknown) => {
    setError(toErrorMessage(err));
  }, []);

  const clearError = React.useCallback(() => setError(null), []);

  return { error, setError, captureError, clearError };
};
